'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { CrossXs } from '@lichtblick/photon/icons/symbols/cross-xs';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './coupon-banner.module.scss';
import { CouponField } from './coupon-field';
export const CouponBanner = ({ couponCode, text, theme })=>{
    const [show, setShow] = useState(true);
    return show ? /*#__PURE__*/ _jsxs("aside", {
        "aria-label": "Banner mit Bonuscode",
        className: classNames(styles.banner, styles[`banner-bg-${theme}`]),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: text
                    }),
                    /*#__PURE__*/ _jsx(CouponField, {
                        couponCode: couponCode
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TextCTA, {
                ariaLabel: "Banner schließen",
                as: "button",
                className: styles['close-button'],
                icon: /*#__PURE__*/ _jsx(CrossXs, {}),
                onClick: ()=>setShow(false)
            })
        ]
    }) : null;
};

//# sourceMappingURL=index.js.map